import { getURLParameter } from 'utils';

const getDeeplink = (url) => {
	if (getURLParameter('feEnv')) {
		url = url + `-${getURLParameter('feEnv')}` + '&feEnv=' + getURLParameter('feEnv');
	}
	if (getURLParameter('beEnv')) {
		url = url + `&beEnv=${getURLParameter('beEnv')}`;
	}

	if (getURLParameter('home-version')) {
		url = url + `&home-version=${getURLParameter('home-version')}`;
	}

	return url;
};

const GLOBAL_CONSTANT = {
	GYFTR: 'GYFTR',
	ONDC_MAGICPIN: 'ONDC_MAGICPIN',
	PSP_MODAL_STATUS: {
		NO_PSP_INSTALLED: 'NO_PSP_INSTALLED',
		INVALID_PARAMS: 'INVALID_PARAMS',
		USER_CLOSED: 'USER_CLOSED',
	},
	API_STATUS: {
		SUCCESS: 1,
		LOADING: 0,
		FAIL: -1,
	},
	STATUS_REFRESH_API_TIMEOUT: 10000,
	STATUS_REFRESH_API_MAX_COUNT: 60,
	STATUS_CONSTANT: {
		success: 'Successful',
		failed: 'Failed',
		failure: 'Failed',
		pending: 'Pending',
		cancelled: 'Cancelled',
		parked: 'Successful',
		reverted: 'Reverted',
		hold: 'Disputed',
	},
	SUPERAPP_MIGRATION: {
		INPROGRESS: 'IN_PROGRESS',
		FAILURE: 'FAILURE',
		SUCCESS: 'SUCCESS',
	},
	PL_DEEPLINK: getDeeplink(`postpe://dynamic?key=postpe-loan`),
	BBPS_DEEPLINK: getDeeplink(`postpe://dynamic?key=bill-payment`),
	POSTPE_DEEPLINK: getDeeplink(`postpe://dynamic?key=home`),
	POSTPE_V2_DEEPLINK: getDeeplink(`postpe://dynamic?key=home-v2`),
	WROUTE: {
		WAITLIST: 'waitlist',
		OFFERS_TEST: 'offersTest',
		OFFERS: 'offers',
		TNC: 'tnc',
		AGREEMENT_ONBOARDING: 'agreementOnboarding',
		CHARGES: 'charges',
		REFER_N_EARN: 'refernearn',
		TXN_LIST: 'txnList',
		CC_TXN_LIST: 'ccTxnList',
		ORDER_CARD: 'orderCard',
		ACTIVATE_CARD: 'activateCard',
		BILL: 'bill',
		ICC: 'icc',
		SCAN_N_PAY: 'scanPay',
		CARD: 'card',
		TXN_STATUS: 'txnStatus',
		CONSUMER_TXN_STATUS: 'consumerTxnStatus',
		MATCH_DETAILS: 'matchDetails',
		CC_TXN_STATUS: 'ccTxnStatus',
		SEND_MONEY: 'sendMoney',
		LIMITS: 'limits',
		CREDIT_CARD: 'creditCard',
		CC_SECURE_NOW: 'ccSecureNow',
		CRM_PAYMENT_LINK: 'crmPaymentLink',
		SANCTION_LETTER: 'sanctionLetter',
		QR_CHARGES_SCREEN: 'qrCharges',
		CLEAR_DUES: 'clearDues',
		FAQS: 'faqs',
		WC_REWARDS: 'wcRewards',
		WC_IPHONE_WINNERS: 'iPhoneWinners',
		WC_POSTPE_SUPER_STRIKERS: 'postpeSuperStrikers',
		BBPS_CHILL_FEST: 'chillFest',
		BBPS_HOME_SCREEN: 'bbpsHomeScreen',
		BBPS_CHILL_FEST_KNOW_MORE: 'chillFestKnowMore',
		BBPS_CHILL_FEST_CONSENT: 'chillFestConsent',
		RATING: 'rating',
		LOAD_PAY_TXN_STATUS: 'loadPayTxnStatus',
		LOAD_PAY_GET_STARTED: 'loadPayGetStarted',
		SOFT_UPDATE_APP: 'softUpdateApp',
		FLEXCARDS: 'flexcards',
		CARD_CLOSURE: 'cardClosure',
		CASH_BACK: 'cashBack',
		PROFILE: 'profile',
		LOAN_CONSENT: 'loanConsent',
		LOAN_STATUS: 'loanStatus',
		LOAN_EMI_DETAILS: 'emiDetails',
		LNT_PROCESSING_INFO: 'lntProcessingInfo',
		LNT_LOAN_LANDING: 'lntLoanConsent',
		LNT_LOANS: 'lntLoans',
		LNT_ACTIVE_LOAN: 'lntActiveLoan',
		LNT_RESUME_APPLICATION: 'lntResumeApplication',
		LNT_APP_STATUS_REJECTED: 'lntAppStatusRejected',
		CHECK_LOAN_ELIGIBILITY: 'checkLoanEligibility',
		SCRATCHCARD: 'scratchCards',
		auCc: 'auCc',
		REWARDS_FAQS: 'rewardFaq',
		CCBP_EDUCATION: 'ccbpEducation',
		ONBOARDING_UPGRADE: 'onboardingUpgrade',
		LENDER_MIGRATION: 'lenderMigration',
		QR_AMOUNT_INSERTION: 'qrAmountInsertion',
		CDL_INTRO: 'cdlIntro',
		BILL_VIEW: 'billView',
		POSTPAID_LOANS: 'postpaidLoans',
		AU_CREDIT_CARD: 'auCreditCard',
		BANNER_KNOW_MORE: 'bannerKnowMore',
		LOANS: 'loans',
		SUPER_APP_HOME: 'superAppHome',
		EMI_CONVERSION: 'emiConversion',
		SHOW_COACHMARKS: 'showCoachmarks',
		DSA_GET_STARTED: 'dsaGetStarted',
		ACCOUNT_DETAILS: 'accountDetails',
		POSTPE_REPAYMENT: 'postpeRepayment',
		POSTPE_BILL_HISTORY: 'postpeBillHistory',
		POSTPE_VIDEOS: 'postpeVideos',
		POSTPE_PRIVACY_SETTING: 'postpePrivacySetting',
	},
	URL_PARAMETER: {
		WROUTE: 'wroute',
		ORDER_ID: 'OrderId',
		TXN_ID: 'txnId',
		APPVERSION: 'appversion',
		CID: 'cid',
		CONSUMER_ID: 'consumerId',
		DEVICE_ID: 'deviceId',
		INSTALL_ID: 'installId',
		IS_VIRTUAL: 'is_virtual',
		LATITUDE: 'latitude',
		LONGITUDE: 'longitude',
		MANUFACTURER: 'manufacturer',
		MODEL: 'model',
		PLATFORM: 'platform',
		ROUTING_KEY: 'routing_key',
		SERIAL: 'serial',
		SIM_ID: 'simId',
		VERSION: 'version',
		VISA: 'visa',
		TOKEN: 'token',
		SECURECARDID: 'order_id',
		ORDERID: 'orderId',
		ID: 'id',
		BBPSBACK: 'bbps_back',
		CAHSH_BACK_RET: 'cashBackRet',
		SOURCE: 'source',
		NOTIF: 'notif',
		CRM: 'CRM',
		CB_BACK: 'sc_back',
		NEW_LOGIN: 'newLogin',
		ACTIVE_TENURE: 'activeTenure',
	},
	DEFAULT_LOADER: {
		first_message: 'loading',
		start_index: 0,
		range: 7,
		second_message: 'please wait',
	},

	SUB_TXN_TYPE: {
		QR_CONVENIENCE_FEE: 'QR_CONVENIENCE_FEE',
		CARD_CHARGES_FEE: 'CARD_CHARGES_FEE',
	},

	//app min versions
	MINIMUM_STABLE_VERSION: {
		ANDROID: 110,
		IOS: 101,
	},

	LATEST_STABLE_VERSION: {
		ANDROID: 129,
		IOS: 113,
	},

	MINIMUM_JUSPAY_VERSION: {
		ANDROID: 125,
		IOS: 113,
	},
	//POST CARD STATUSES
	CARD_STATUSES: {
		BLOCKED: 'BLOCKED',
		EXPIRED: 'EXPIRED',
	},

	LINKS: {
		APP_STORE: 'https://apps.apple.com/in/app/postpe/id1586002156',
		PLAY_STORE: 'https://play.google.com/store/apps/details?id=com.postpe.app',
	},
	LENDER: {
		HINDON: 'HINDON',
		LDC: 'LDC',
		TRILLION: 'TRILLION',
		LIQUILOANS: 'LL',
	},
	ACCOUNT_STATUS: {
		POSTPAID: 'POSTPAID',
	},
	PLATFORM: {
		IOS: 'IOS',
		ANDROID: 'Android',
	},

	CCBP_PVP_BANNER_SCREENS: {
		POSTPE_HOME: 'ccbp_pvp_banner_postpe_home',
		CCBP_HOME: 'ccbp_pvp_banner_ccbp_home',
		TXN_STATUS: 'ccbp_pvp_banner_txn_status',
	},
	THIRD_PARTY: {
		MAGIC_DEEPLINK: '&cat=ondc&client=magicpin',
		GYFTR_DEEPLINK: '&cat=gv&client=gyftr',
		CLIENT: 'client',
		CAT: 'cat',
	},

	HOME_VERSION: {
		superApp: 'super-app',
	},
	EXCLUDE_WROUTE_SUPERAPP: [
		'bannerKnowMore',
		'creditCard',
		'profile',
		'cashBack',
		'offers',
		'auCreditCard',
		'txnStatus',
		'billView',
		'postpaidLoans',
		'sendMoney',
		'limits',
		'qrAmountInsertion',
		'rating',
		'ccbpEducation',
		'qrAmountInsertion',
		'emiConversion',
		'tnc',
		'agreementOnboarding',
		'ccTxnStatus',
		'txnList',
		'ccTxnList',
		'postpePrivacySetting',
		'postpeVideos',
		'postpeBillHistory',
		'postpeRepayment',
		'accountDetails',
		'refernearn',
		'charges',
		'faqs',
	],
};

export default GLOBAL_CONSTANT;
